import React from 'react';
import {
  isCateringDisposition,
  isDeliveryDisposition,
  isDineInDisposition,
  isPickupDisposition,
} from 'common/utilities/utils';

import {
  getCateringOrderPanelJSX,
  getDeliveryOrderPanelJSX,
  getPickupOrderPanelJSX,
} from 'organisms/orderSummaryViews/presentation/sharedTemplates/orderSummaryViewTemplates';
import {
  getOrderSummaryModals,
  getCallSupportModalView,
} from 'organisms/orderSummaryViews/utils/orderSummaryModelViewUtils';
import { useSelector } from 'react-redux';

const OrderSummaryView = props => {
  const isCheckinLoading = useSelector(state => state.postOrderReducer?.checkInRequestLoading);
  const { orderDetails } = props;
  const { service, displayOrderProcessingPage, enableRetryCountForPickupOrderTracking, openCallSupportModal, showOrderStatus } =
    orderDetails;
  props = { ...props, isCheckinLoading };
  return (
    <React.Fragment>
      {!displayOrderProcessingPage && showOrderStatus && (
        <div
          className={`orderSummaryPage au col-12 ${service} ${
            enableRetryCountForPickupOrderTracking && 'ordersummaryInfo-icon'
          }`}
        >
          {isDeliveryDisposition(service) && getDeliveryOrderPanelJSX(props)}
          {isPickupDisposition(service) && getPickupOrderPanelJSX(props)}
          {isDineInDisposition(service) && getPickupOrderPanelJSX(props)}
          {isCateringDisposition(service) && getCateringOrderPanelJSX(props)}

          {getOrderSummaryModals(props)}
        </div>
      )}
      {openCallSupportModal && getCallSupportModalView(openCallSupportModal, props.updateSetOrderDetails)}
    </React.Fragment>
  );
};

export default React.memo(OrderSummaryView);
